import React, { useState, useRef } from "react";
import { Toast, Overlay } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { IconButton, Popover, TextField } from '@mui/material';
import { Autorenew, ContentCopyOutlined, ContentCopyRounded, ContentCopyTwoTone } from "@mui/icons-material";
import GenAITemplateContentItem from "./GenAITemplateContentItem";

// Accordion Component with Expand/Collapse Arrow
const Accordion = ({ title, children }) => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleAccordion = () => setIsOpen(!isOpen);

    return (
        <div
            style={{
                marginBottom: "10px",
                border: "1px solid #ddd",
                borderRadius: "8px",
                overflow: "hidden",
            }}
        >
            <div
                onClick={toggleAccordion}
                style={{
                    backgroundColor: "#f0f0f0",
                    padding: "10px 15px",
                    cursor: "pointer",
                    fontWeight: "bold",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                }}
            >
                <span>{title}</span>
                <span style={{ transform: isOpen ? "rotate(180deg)" : "rotate(0deg)", transition: "transform 0.2s" }}>
                    <span className="icon-ico_down-arrow-1 align-right ml-2" style={{ fontWeight: "800" }}></span>
                </span>
            </div>
            {isOpen && (
                <div style={{ padding: "10px 15px", backgroundColor: "#fff" }}>
                    {children}
                </div>
            )}
        </div>
    );
};

const DynamicAccordionPage = ({ data, userInputData }) => {


    const formatText = (text) => {
        const words = text.match(/[A-Z][a-z]+|[a-z]+|\d+/g);
        return words
            .map((word) =>
                /\d/.test(word) ? word : word.charAt(0).toUpperCase() + word.slice(1)
            )
            .join(" ");
    };

    const renderSection = (section, sectionKey) => (
        <Accordion key={sectionKey} title={formatText(sectionKey)}>
            {section &&
                Object.entries(section).map(([key, value]) => {
                    if (typeof value === "object" && !Array.isArray(value)) {
                        return renderSection(value, key);
                    } else if (Array.isArray(value) && typeof value[0] === "string") {
                        return (
                            <div key={key} style={{ marginBottom: "10px" }}>
                                <label style={{ display: "block", fontWeight: "bold", flex: "1" }}>{formatText(key)}</label>
                                {value.map((item, index) => (
                                   <GenAITemplateContentItem contentKey={""} contentValue={item} userInputData={userInputData}/>
                                ))

                                }

                            </div>
                        );
                    } else if (Array.isArray(value)) {
                        return renderArray(value, key);
                    } else {
                        return (
                            <GenAITemplateContentItem contentKey={key} contentValue={value} userInputData={userInputData} sectionName={formatText(sectionKey)}/>
                        );
                    }
                })}
        </Accordion>
    );

    const renderArray = (array, arrayKey) => (
        <Accordion key={arrayKey} title={formatText(arrayKey)}>
            {array &&
                array.map((item, index) => {
                    if (typeof item === "string") {
                        return (
                            <ul key={index} style={{ paddingLeft: "20px", marginBottom: "10px" }}>
                                <li>{item}</li>
                            </ul>
                        );
                    } else if (Array.isArray(item)) {
                        return renderArray(item, `${arrayKey}-${index}`);
                    } else if (typeof item === "object") {
                        return renderSection(item, `${arrayKey}-${index}`);
                    }
                })}
        </Accordion>
    );

    return (
        <div style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}>
            <h1 style={{ textAlign: "center", marginBottom: "10px" }}>{data.sectionName}</h1>
            <h2 style={{ textAlign: "center", color: "#888", marginBottom: "20px" }}>{data.sectionType}</h2>
            {Object.entries(data).map(([key, value]) => {
                if (key === "sectionName" || key === "sectionType") return null;
                if (Array.isArray(value)) {
                    return renderArray(value, key);
                } else if (typeof value === "object") {
                    return renderSection(value, key);
                } else {
                    return (
                        <GenAITemplateContentItem contentKey={key} contentValue={value} userInputData={userInputData}/>
                    );
                }
            })}
        </div>
    );
};

export default DynamicAccordionPage;
